import { getAvatarColor } from '@forwardflow/helpers/utils'
import { UserAvatar } from '@forwardflow/ui'

export const CallSummaryLeadMessageItem = ({
   data,
   selectedLeadDetails,
}: any) => {
   return (
      <div className="flex items-end justify-start gap-x-2">
         <UserAvatar
            backgroundColor={getAvatarColor(
               selectedLeadDetails?.stageInfo?.name
            )}
            className="!w-10 !h-10 !text-[14px]"
         >
            {selectedLeadDetails?.userInfo?.firstName.slice(0, 1) || 'L'}
         </UserAvatar>
         <div className="flex flex-col items-start gap-y-1">
            <div className="flex flex-col justify-between bg-white/10 py-4 px-5 max-w-[450px] rounded-3xl rounded-bl-none gap-y-1">
               <p className="text-[14px] font-medium">{data?.content}</p>
            </div>
         </div>
      </div>
   )
}
